import { render, staticRenderFns } from "./threeSeletOne.vue?vue&type=template&id=5ffef722&scoped=true"
import script from "./threeSeletOne.vue?vue&type=script&lang=js"
export * from "./threeSeletOne.vue?vue&type=script&lang=js"
import style0 from "./threeSeletOne.vue?vue&type=style&index=0&id=5ffef722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffef722",
  null
  
)

export default component.exports